export const createReducer = (reducer, state, action) => {
  return reducer[action.type] ? reducer[action.type](state, action) : state;
};
